import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import MerchantApp from "@/pages/MerchantApp";
import AdminApp from "@/pages/AdminApp";
import KioskPage from "@/pages/KioskPage";
import WalletPassPage from "@/pages/WalletPassPage";
import { PrivacyPage, TermsPage, ContactPage } from "@/pages/LegalPages";

function Protected({ role, children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#f9f9fb]">
        <div className="text-sm uppercase tracking-[0.2em] font-semibold text-[#002fa7]">Loading</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin/*" element={<Protected role="admin"><AdminApp /></Protected>} />
            <Route path="/merchant/*" element={<Protected role="merchant"><MerchantApp /></Protected>} />
            <Route path="/kiosk/:slug" element={<KioskPage />} />
            <Route path="/pass/:token" element={<WalletPassPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
